import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import styled from 'styled-components'
import shortid from 'shortid'
import moment from '../../lib/moment.js'
import get from 'lodash/get'
import { leave_type_table_header, FONTS, COLORS } from '../../constants'

export default class LeaveTypeTable extends React.Component {
  render() {
    return (
    /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        <NewTable bordered hover>
          <Header>
            <tr>
              {
                leave_type_table_header.map((h) =>
                  <HeadTable key={ shortid() }>{ h }</HeadTable>
                )}
            </tr>
          </Header>
          <BodyTable >
            {
              get(this.props, 'leaveType', []).map((d, key) =>
                (<tr
                  key={ shortid() }
                  style={ { hover: '#E5E5E5', background: (key === get(this.props, 'rowID') && get(this.props, 'isSpan')) ? '#E5E5E5' : '' } }
                  onClick={ () => this.props.handleClickRow(true, d._id, key) }
                >
                  <td>{ moment(d.start_date).format('DD/MM/YYYY') }</td>
                  <td>{ moment(d.end_date).format('DD/MM/YYYY') }</td>
                  <td>{ d.leave_type_code }</td>
                  <td>{ d.name }</td>
                </tr>)
              )}
          </BodyTable >
        </NewTable>
      </Wrapper>
    )
  }
}

LeaveTypeTable.propTypes = {
  handleClickRow: PropTypes.func.isRequired,
}

const Wrapper = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`
const NewTable = styled(Table)`
  background: white;
  thead, tbody tr{
    display: table;
    width: 100%;
    table-layout: fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE};
  }
`
const BodyTable = styled.tbody`
  width: 100% ;
  display: block ;
  max-height: calc(100vh - 200px);
  overflow-y:scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`
const HeadTable = styled.th`
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
    font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const Header = styled.thead`
  background: ${COLORS.TABLE_HEADER_COLOR};
`



// WEBPACK FOOTER //
// ./src/components/table-leave-type/index.js